import React from 'react'
import { DatePicker } from "antd";
import { Field } from "./index";
import moment from "moment";
import { FieldBase } from "./components/FieldBase";

// Formato en el que se guarda/envía el valor (hora local, sin zona horaria)
const VALUE_FORMAT = 'YYYY-MM-DD HH:mm';

// Convierte un valor del backend a moment en hora local.
// Acepta 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD' y también ISO con zona ('...T08:30:00.000Z')
// que se guardaba antes al serializar el moment directamente con JSON.
const parseDateTime = (value) => {
  if (!value) return undefined;
  if (moment.isMoment(value)) return value;
  // 'DD-MM-YYYY ...' es el formato con el que getURLWithFilter lo pone en la URL de los dashboards
  let result = moment(value, [VALUE_FORMAT, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm', 'DD-MM-YYYY HH:mm', 'YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY'], true);
  if (!result.isValid())
    result = moment(value, moment.ISO_8601);
  return result.isValid() ? result : undefined;
}

export class FieldDateTime extends Field {

  constructor(obj = {}) {
    super(obj);
  }

  getComponent (form, fieldChanged) {
    const dateTimeFormat = ['DD/MM/YYYY HH:mm'];
    const disabled = this.disabled;

    const DateTimeInput = ({ value, onChange }) => (
      <DatePicker
        disabled={disabled}
        format={dateTimeFormat}
        showTime={{ format: 'HH:mm' }}
        style={{ width: '100%' }}
        value={parseDateTime(value) ?? null}
        onChange={(val) => {
          if (fieldChanged) fieldChanged();
          onChange(val ? val.format(VALUE_FORMAT) : null);
        }}
      />
    );

    return () => (
      <FieldBase
        condition={this.condition}
        form={form}
        size={this.size}
        label={this.label}
        name={this.name}
        value={this.value}
        help={this.help}
        rules={this.rules}
      >
        <DateTimeInput />
      </FieldBase>
    );
  }

  transformToField = (data) => {
    this.name = data.name;
    this.label = data.label;
    this.type = data.type;
    this.size = data.size ?? this.size;
    this.value = this.transformValueToDate(data.value ?? data.defaultValue);
    this.condition = data.condition ?? true;
    this.disabled = data.disabled ?? false;
    this.help = data.help;
    this.rules = data.rules;

    return this;
  }

  transformValueToDate = (str) => {
    const result = parseDateTime(str);
    return result ? result.format(VALUE_FORMAT) : undefined;
  }

  transformValueToField = (data) => {
    const result = parseDateTime(data);
    return result ? result.format(VALUE_FORMAT) : undefined;
  };
}
